import { api } from "@api/api";
import { Prescriber } from "@modules/prescribers/types";
import { PrescriberFormValues } from "@modules/prescribers/validations";

export async function editPrescriberService(id: string, data: PrescriberFormValues): Promise<Prescriber> {
  const { data: prescriber } = await api.patch<Prescriber>(`v1/prescriber_admin/${id}/`, data);

  return prescriber;
}
